<template>
    <div>
        <span v-if="subscription && subscription.plan">{{ subscription.plan.name }}</span>
        <br/>
        <span v-if="statusDisplay" class="subscription-status-tag" :style="tagStyle">{{ statusDisplay }}</span>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tagColor: ''
            }
        },

        props: {
            subscription: {
                required: true
            }
        },

        computed: {
            statusDisplay() {
                if (this.subscription) {
                    switch (this.subscription.status) {
                        case 'active':
                            this.tagColor = '#67c23a'
                            return 'active'
                        case 'cancelled':
                            this.tagColor = '#f56c6c'
                            return 'cancelled'
                        case 'non_renewing':
                            this.tagColor = '#e2e60d'
                            return 'non-renewing'
                        case 'in_trial':
                            return 'in-trial'
                        default:
                            return this.subscription.status
                    }
                }
            },
            tagStyle() {
                return {background: this.tagColor}
            }
        }
    }
</script>
